import { memo, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import {
  CustomAutocompleteType,
  PropType,
} from "../../../utilis/component/CustomFormElement";
import { RosType } from "./types";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { useQuery } from "react-query";
import {getRosBs} from "../../services"
const filter = createFilterOptions<RosType>({
  stringify: (option) => option.rosName, // Important
});

const textColorClass = "text-grey-500";
type PhysicalEaminationAutocompleteType = PropType & {
  handleOperation?: (param: { prev: RosType[]; current: RosType[] }) => void;
  id?: number;
};
const PhysicalExaminationAutocomplete = memo((
  props: PhysicalEaminationAutocompleteType,
) => {
  const { data: options, isLoading } = useQuery(
    [`ROSinPhysicalExaminationAutocomplete${props.id}`, props.id],
    async () => getRosBs({ id: Number(props.id), text: "" }),
    {
      enabled: !!props.id,
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus:false,
    },
  );

  const { control, name, rules, fieldProps, handleOperation, id } = props;

  useEffect(()=>{
  console.log("inside PhysicalExaminationAutocomplete => ",props)
  },[props])
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { ref, onChange, value = null, ...field },
        fieldState: { error },
      }) => {
        return (
          <Autocomplete
            {...field}
            {...((props as CustomAutocompleteType).autocompleteProps as any)}
            options={options?.response || []}
            loading={isLoading}
            value={value || []}
            onChange={(_, data) => {
              handleOperation &&
                handleOperation({ prev: value, current: data as RosType[] });
              onChange(data || []);
            }}
            disableClearable={true}
            filterOptions={(options, params) => {
              const filtered = filter(options as RosType[], params);
              if (filtered.length === 0 && params.inputValue !== "") {
                return [
                  {
                    rosName: params.inputValue,
                    rosId: 0,
                    physicalExamId: 0,
                    bodySystemId: id,
                  },
                ];
              }
              return filtered;
            }}
            renderInput={(params) => (
              <TextField
                inputRef={ref}
                {...params}
                {...field}
                // {...fieldProps}
                label={
                  <span className={textColorClass}>
                    {String(fieldProps.label).toUpperCase()}{" "}
                    {rules.required && <span className="text-red-500">*</span>}
                  </span>
                }
                error={!!error}
                helperText={error?.message || ""}
              />
            )}
          />
        );
      }}
    />
  );
});

export default PhysicalExaminationAutocomplete;
